import * as React from 'react';
import { Link } from 'react-router-dom';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import EnterpriseInformationFormComponent from './EnterpriseInformationForm.component';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import LegalDocumentationFormComponent from './LegalDocumentationForm.component';
import JuridicalInformationFormComponent from './JuridicalInformationForm';
import IdentificationJuridicalDocumentsFormComponent from './IdentificationJuridicalDocumentsForm';
import JuridicalAddressFormComponent from './JuridicalAddressForm';
import JuridicalAdditionalDataFormContainer from './JuridicalAdditionalDataForm.container';
import JuridicalProfileFormComponent from './JuridicalProfileForm.component';
import JuridicalSpouseDataFormComponent
  from 'src/modules/my-account/juridical-profile-update/forms/JuridicalSpouseDataForm.component';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import Person from 'src/entities/Person';

export interface JuridicalPersonEditFormComponentProps {
  juridicalPerson?: JuridicalPerson;
  formData: JuridicalPersonData;
  handleSubmit: (edit: boolean) => void;
  handleChange: (key: string) => (value: string | File | boolean) => void;
  handleChangeSpouse: (key: string) => (value: string | File | boolean) => void;
  handleChangeDefaultProfile: () => void;
  error: boolean;
  errorMessage: {};
  physicalPerson: PhysicalPerson;
  cifDocument?: File;
  cifDocumentName?: string;
  deedCompany?: File;
  deedCompanyName?: string;
  companyStatutes?: File;
  companyStatutesName?: string;
  realOwnership?: File;
  realOwnershipName?: string;
  idRepresentatives?: File;
  idRepresentativesName?: string;
  notarialDeed?: File;
  notarialDeedName?: string;
  profilePicture?: File;
  profilePictureName?: string;
  idFront?: File;
  idFrontName?: string;
  idBack?: File;
  idBackName?: string;
  defaultProfile: Person;
  checkboxState: boolean;
  canChangeCheckbox: boolean;
  handleChangeCheckbox: () => void;
  handlePublicProfileCheckbox: () => void;
  lockCreateJuridicalPerson: boolean;
}

class JuridicalPersonEditFormComponent extends React.PureComponent<JuridicalPersonEditFormComponentProps> {
  public render(): React.ReactNode {
    return (
      <div className="tab-content">
        <div className="gap-10"/>
        <Link to="/mi-cuenta/perfil">
          <span className="close pointer close-form"/>
        </Link>
        <div className="gap-20"/>
        <div className="text-center">
          <h4 className="f-s-16 margin-0-auto text-center">
            <span className="primary-font f-w-100">
              {this.props.formData.enterpriseName}
            </span>

            <br/>
            <span className="primary-font f-w-100">
              Persona Jurídica
            </span>
            <br/>
          </h4>
          <div className="gap-20"/>
          {this.props.juridicalPerson ?
            <p className="margin-0-auto text-center">
              <Link
                to="/mi-cuenta/tipo-de-inversor"
                className="no-credit-link"
              >
                Inversor {this.props.juridicalPerson.investorType.type.toLowerCase()}
                {this.props.juridicalPerson.investorType.confirmed ?
                  <span className="no-credit"/> :
                  null
                }
              </Link>
            </p> :
            <p className="margin-0-auto text-center">
              <Link
                to="/mi-cuenta/tipo-de-inversor"
                className="no-credit-link"
              >
                Inversor no acreditado
                <span className="no-credit"/>
              </Link>
            </p>
          }
        </div>
        <div className="gap-20"/>
        <hr/>
        <div className="padding-40">
          {this.props.formData.id ?
            <div>
              <p>
                <strong>
                  Elige el perfil predeterminado para realizar las inversiones:
                </strong>
              </p>
              <div className="gap-20"/>
              <div className="checkbox">
                <input
                  type="checkbox"
                  checked={this.props.checkboxState}
                  onChange={() => ({})}
                />
                <label
                  onClick={(e) => this.props.handleChangeCheckbox()}
                >
                  Deseo que este perfil sea mi predeterminado.
                </label>
              </div>
            </div>
            : null
          }
          <div className="gap-20"/>
          <h3 className="inline-block f-s-22 deco-title">
            Representante
          </h3>
          <div className="gap-20"/>
          <p><strong>Si el representante es usted, para facilitar el proceso de relleno de campos, puede copiar los
            datos:</strong></p>
          <div className="gap-20"/>
          <label className="switch">
            <input
              type="checkbox"
              defaultChecked={false}
              onChange={(checked) => this.props.handleChange('copy')(!checked)}
            />
            <span className="slider round"/>
          </label>
          <span className="switch-text">
            Copiar datos de {this.props.physicalPerson.name + ' ' +
          this.props.physicalPerson.surname}
          </span>
          <div className="gap-20"/>
          <h3 className="inline-block f-s-22 deco-title">
            Sociedad
          </h3>
          <div className="faqAccordion">
            <JuridicalInformationFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            <IdentificationJuridicalDocumentsFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
              idFront={this.props.idFront}
              idBack={this.props.idBack}
            />
            <JuridicalAddressFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            <JuridicalAdditionalDataFormContainer
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            {this.props.formData.maritalStatus === 'Casado/a' &&
            this.props.formData.maritalEconomicStatus === 'Régimen de gananciales' ?
              <JuridicalSpouseDataFormComponent
                formData={this.props.formData}
                handleChangeSpouse={this.props.handleChangeSpouse}
              /> :
              null
            }
            <EnterpriseInformationFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
            />
            <LegalDocumentationFormComponent
              handleChange={this.props.handleChange}
              cifDocument={this.props.cifDocument}
              cifDocumentName={this.props.cifDocumentName}
              deedCompany={this.props.deedCompany}
              deedCompanyName={this.props.deedCompanyName}
              companyStatutes={this.props.companyStatutes}
              companyStatutesName={this.props.companyStatutesName}
              realOwnership={this.props.realOwnership}
              realOwnershipName={this.props.realOwnershipName}
              idRepresentatives={this.props.idRepresentatives}
              idRepresentativesName={this.props.idRepresentativesName}
              notarialDeed={this.props.notarialDeed}
              notarialDeedName={this.props.notarialDeedName}
            />
            <JuridicalProfileFormComponent
              formData={this.props.formData}
              handleChange={this.props.handleChange}
              profilePicture={this.props.profilePicture}
            />
          </div>
          <p>
            <div className="gap-20"/>
            <div className="checkbox">
              <input
                type="checkbox"
                checked={this.props.formData.isPublicProfile}
                onChange={() => ({})}
              />
              <label
                onClick={(e) => this.props.handlePublicProfileCheckbox()}
              >
                Marcar perfil como público, los usuarios registrados podrán ver su perfil.
              </label>
            </div>
          </p>
          <div className="text-right">

            {this.props.formData.id ?
              <button
                type="button"
                className="btn btn-primary"
                data-container="body"
                data-html="true"
                data-toggle="popover"
                data-placement="bottom"
                onClick={(e) => this.props.handleSubmit(true)}
              >
                Actualizar
              </button> :
              <button
                type="button"
                className="btn btn-primary"
                data-container="body"
                data-html="true"
                data-toggle="popover"
                data-placement="bottom"
                onClick={(e) => this.props.handleSubmit(false)}
                disabled={this.props.lockCreateJuridicalPerson}
              >
                Crear
              </button>
            }
            <div className="gap-20"/>
            <ErrorMessagesComponent
              errorMessage={this.props.errorMessage}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default JuridicalPersonEditFormComponent;


// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/forms/JuridicalPersonEditForm.component.tsx